import React, { useState, useEffect, useCallback } from "react";

import { useParams } from 'react-router-dom';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Text,
  Heading,
  Button,
  useToast,
  useColorModeValue,
  Flex,
  VStack,
  Tbody,
  Table,
  Tr,
  Td,
  Th,
  Thead,
  IconButton,
  HStack,
  Badge,
  Select,
  useDisclosure,
  Checkbox,
  Textarea,

} from "@chakra-ui/react";
import axios from "axios";
import { FiTrash, FiCheck, FiX, FiEdit } from "react-icons/fi";
import { jwtDecode } from "jwt-decode";
import { Offer,Product, OfferProductMapping, OfferDomainPlacement } from '../../Platform/Common/types';
import { addMinutes } from 'date-fns'; // You can also manually add mins without this
import ReactSelect from 'react-select';
import { useNavigate } from "react-router-dom";
import { Domain } from '../../Platform/Common/types';


interface TokenPayload {
    sub: string;
    role_id: number;
    tenant_id: number;
    exp?: number;
  }

  const B2CReviewOffer = () => {
    // ────────────────────────────────────────────────────────────────────────────
    // Theme & routing hooks
    // ────────────────────────────────────────────────────────────────────────────

    const cardbg = useColorModeValue("gray.50", "gray.700");
  
    const { offer_id } = useParams<{ offer_id: string }>();
    const [offerId, setOfferId] = useState<number>(Number(offer_id));
    const navigate = useNavigate();
    const toast = useToast();

    const { domain_id } = useParams<{ domain_id: string }>();

  
    // ────────────────────────────────────────────────────────────────────────────
    // State: core offer, products, mappings
    // ────────────────────────────────────────────────────────────────────────────

  
    const [offer, setOffer] = useState<Offer>({
      offer_id: 0,
      domain_id: Number(domain_id),
      name: '',
      slug:'',
      description: '',
      status:"DRAFT",
      total_price:0,
      is_free:false,
      currency:process.env.REACT_APP_PLATFORM_CURRENCY || "AUD",
      created_at: new Date(),
      updated_at: new Date(),
    });

    const [offerDomainPlacement, setOfferDomainPlacement] = useState<OfferDomainPlacement>({
      offer_id: 0,
      domain_id: Number(domain_id),
      sequence: undefined,
      badge_text: '',
      badge_theme:"BLUE",
      promotion_tier:"STANDARD",
      theme_key:"BLUE",
      created_at: new Date(),
      updated_at: new Date(),
    });
  
    const [products, setProducts] = useState<Product[]>([]);

    const [domains, setDomains] = useState<Domain[]>([]);
    const [isPsetEdited, setIsPsetEdited] = useState(false);
  
    type EditableMapping = OfferProductMapping & { isDraft?: boolean };

    const [mappings, setMappings] = useState<EditableMapping[]>([]);
    const [isMappingEdited, setIsMappingEdited] = useState(false);
    const [isOfferEdited, setIsOfferEdited] = useState(false);
    const [isPlacementEdited, setIsPlacementEdited] = useState(false);
    
  
  
    // ────────────────────────────────────────────────────────────────────────────
    // Mode & button logic
    // ────────────────────────────────────────────────────────────────────────────
    const [isEditing, setIsEditing] = useState(false);
    const isCreating = offerId === 0;
    const isViewMode = !isEditing;

    const isDraft     = offer.status === "DRAFT";
    const isActive = offer.status === "ACTIVE";

    const isArchived = offer.status === "ARCHIVED";
  
    const showActionButtons    = !isCreating;
    const showSaveButton       = isCreating || !isViewMode;
    const isUpdateButtonEnabled   = showActionButtons && isViewMode && !isArchived;

    const isPublishButtonEnabled   = showActionButtons && isViewMode && isDraft;

    const isArchivedButtonEnabled   = showActionButtons && isViewMode && isActive;

   
      const buttonBg = useColorModeValue(
        'linear-gradient(to right, blue.50, blue.100)',
        'linear-gradient(to right, blue.600, blue.700)'
      );

        const buttonHoverBg = useColorModeValue(
          'blue.200',
          'blue.500'
        );

    // ────────────────────────────────────────────────────────────────────────────
    // API fetchers
    // ────────────────────────────────────────────────────────────────────────────
    const fetchOffer = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<Offer>(`${b2c_apiurl}/offer/${offer_id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setOffer(data);
    };

  const fetchOfferDomainPlacement = async () => {
      try {
        const b2c_apiurl =
          process.env.REACT_APP_B2C_API_URL || "https://default-url.com";

        const { data } = await axios.get<OfferDomainPlacement>(
          `${b2c_apiurl}/offer/${offer_id}/placement`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("b2c_token")}`,
            },
          }
        );

        setOfferDomainPlacement(data);
      } catch (err: any) {
        if (err.response?.status === 404) {
          // placement not created yet — that's fine
          console.log("Placement not found yet.");
        } else {
          console.error(err);
          toast({ title: "Error fetching placement", status: "error" });
        }
      }
  };

    // Write fetchOfferCategories, API has been written and then use Accordion logic - take help from ReviewCourseTerms


    const fetchDomains = async () => {
      try {
        const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
        const response = await axios.get(`${b2c_apiurl}/domains`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('b2c_token')}`,
          },
        });
        setDomains(response.data);
      } catch (error) {
        console.error("Failed to load B2C Domains", error);
      }
    };
  
    const fetchProducts = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<Product[]>(`${b2c_apiurl}/products`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setProducts(data);
    };
  

    const fetchOfferProductMappings = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<OfferProductMapping[]>(`${b2c_apiurl}/offer/${offer_id}/offer-product-mappings`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setMappings(data);
    };
  

    // ────────────────────────────────────────────────────────────────────────────
    // Derived state effects
    // ────────────────────────────────────────────────────────────────────────────

    const loadAllData = useCallback(async () => {
        const token = localStorage.getItem("b2c_token");
        if (!token) return;
      
 
      
        // 2) if editing an existing offer
        if (Number(offer_id) > 0) {
          await fetchOffer();
          await fetchOfferDomainPlacement();
          await fetchOfferProductMappings();
  
          setOfferId(Number(offer_id));
        }
      
        // 3) fetch all remaining lookups
 
          await Promise.all([
            fetchProducts(),
            fetchOfferDomainPlacement(),
            fetchDomains(),
     
          ]);
     
      
        // 4) reset any “edited” flags
        setIsEditing(false);
        setIsMappingEdited(false);
        setIsOfferEdited(false);
        setIsPlacementEdited(false);
      }, [
        offer_id,
        fetchOffer,
        fetchOfferDomainPlacement,
        fetchOfferProductMappings,

        fetchProducts,
        fetchDomains,
 
      ]);

    // 1) On load —  fetch everything
    useEffect(() => {
      (async () => {
        const token = localStorage.getItem("b2c_token");
        if (!token) return;
  
        if (Number(offer_id) > 0) {
          await fetchOffer();
          await fetchOfferDomainPlacement();
          await fetchOfferProductMappings();
          setOfferId(Number(offer_id));
        }
          await fetchProducts();
          await fetchDomains();

      })();
    }, [offer_id]);
  

  
  
    // ────────────────────────────────────────────────────────────────────────────
    // Mapping helpers
    // ────────────────────────────────────────────────────────────────────────────
    // ────────────────────────────────────────────────────────────────────────────
    //  Extend your mapping type locally to carry a draft‐flag
    // ────────────────────────────────────────────────────────────────────────────

    // helper to know if a draft row exists
    const hasDraftMappingRow = () => mappings.some(m => m.isDraft);

    const [mappingBackups, setMappingBackups] = useState<Record<number, OfferProductMapping>>({});

    // ────────────────────────────────────────────────────────────────────────────
    //  Add / confirm / cancel mapping row
    // ────────────────────────────────────────────────────────────────────────────

    // 1) add a *draft* row (only if none exists)
    const addMapping = () => {
        if (hasDraftMappingRow()) return;  // only one draft at a time
      
        // compute nextStartTime exactly as before…
        let nextStart = new Date();
        if (mappings.length) {
          const sorted = [...mappings].sort((a,b)=>a.product_id - b.product_id);
          const last = sorted[sorted.length - 1];
          const pr = products.find(p => p.product_id === last.product_id);
        }
      
        setMappings(prev => [
          ...prev,
          {
            offer_id: Number(offer_id),
            product_id: 0,
            term_id:0,
            sequence : prev.length + 1,
            duration_days : 30,
            isDraft: true,      // ← mark it draft
          }
        ]);
        setIsMappingEdited(true);
      };
      
      // -----------------------------------------------------------------------------
       // 5) Turn an **existing** row into draft/edit mode
      // -----------------------------------------------------------------------------
      const editMapping = (idx: number) => {
        if (hasDraftMappingRow()) return;  // lock while another is open
        // snapshot original
        setMappingBackups(b => ({ ...b, [idx]: { ...mappings[idx] } }));
        // mark draft
        setMappings(prev =>
          prev.map((m,i) => i===idx ? { ...m, isDraft:true } : m)
        );
      };
      
      // -----------------------------------------------------------------------------
       // 6) Confirm (✓) the draft row’s changes
      // -----------------------------------------------------------------------------
      const confirmDraftMapping = (idx: number) => {
        const m = mappings[idx];
        if (!m.product_id) {
          toast({ title: "Please select a Product", status: "warning" });
          return;
        }
        setMappings(prev =>
          prev.map((m,i) => i===idx ? { ...m, isDraft:false } : m)
        );
        // drop its backup
        setMappingBackups(b => {
          const { [idx]:_, ...rest } = b;
          return rest;
        });
        setIsMappingEdited(true);
      };
      
      // -----------------------------------------------------------------------------
       // 7) Cancel (✕) the draft row
      // -----------------------------------------------------------------------------
      const cancelDraftMapping = (idx: number) => {
        if (mappingBackups.hasOwnProperty(idx)) {
          // existing row: restore from backup
          setMappings(prev =>
            prev.map((m,i) =>
              i===idx
                ? ({ ...mappingBackups[idx], isDraft:false })
                : m
            )
          );
          setMappingBackups(b => {
            const { [idx]:_, ...rest } = b;
            return rest;
          });
        } else {
          // brand‐new row: just drop it
          setMappings(prev =>
            prev
              .filter((_,i)=> i!==idx)
              .map((m,i)=> ({ ...m, sequence: i+1 }))
          );
        }
        setIsMappingEdited(true);
      };

    // ────────────────────────────────────────────────────────────────────────────
    //  Your existing deleteMapping + updateMapping + getAvailableProducts
    // ────────────────────────────────────────────────────────────────────────────
    const deleteMapping = (idx: number) => {
    setMappings(prev =>
        prev
        .filter((_, i) => i !== idx)
        .map((m, i) => ({ ...m, sequence: i + 1 }))
    );
    setIsMappingEdited(true);
    };

    const updateMapping = (idx: number, updates: Partial<EditableMapping>) => {
    setMappings(prev =>
        prev.map((m, i) => (i === idx ? { ...m, ...updates } : m))
    );
    setIsMappingEdited(true);
    };

    const getAvailableProducts = (currentIndex: number) => {
    const currentId = mappings[currentIndex]?.product_id;
    const taken = mappings
        .filter((_, i) => i !== currentIndex)
        .map(m => m.product_id);
    return products.filter(
        pr =>
        !taken.includes(pr.product_id) ||
        pr.product_id === currentId
    );
    };


    // ────────────────────────────────────────────────────────────────────────────
    // Form handlers
    // ────────────────────────────────────────────────────────────────────────────
    const handleInputChange = (e: React.ChangeEvent<any>) => {
      const { name, value } = e.target;
      setOffer(prev => ({ ...prev, [name]: value }));
      setIsOfferEdited(true);
    };
  
    // ────────────────────────────────────────────────────────────────────────────
    // Save / Create / Update / Publish / Cancel / Terminate
    // ────────────────────────────────────────────────────────────────────────────
    const handleCreateOffer = async () => {
      try {
        const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
        console.log("Offer", offer);
        const { data } = await axios.post<Offer>(`${b2c_apiurl}/create-offer/`, offer, {
          headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
        const newId = data.offer_id;

            // --- CREATE PLACEMENT ---
        const placementPayload = {
          ...offerDomainPlacement,
          offer_id: newId,
          domain_id: Number(domain_id),
        };

        await axios.post(`${b2c_apiurl}/offer-domain-placement`, placementPayload,{
            headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
          });

        // re-map products
        if (isMappingEdited) {
          await axios.delete(`${b2c_apiurl}/offer/${newId}/delete-offer-product-mappings`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
          });
          console.log("the mappings shared with backend", mappings);
          const mappingPayload = mappings.map(({ isDraft, ...m }) => ({
            ...m,
            offer_id: newId,   // ← force correct FK
          }));

          await axios.post(
            `${b2c_apiurl}/offer/${newId}/create-offer-product-mappings`,
            mappingPayload,
            {
              headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
            }
          );
        }

        toast({ title: "Offer created", status: "success" });
        setIsMappingEdited(false);

        setIsOfferEdited(false);
        setIsPlacementEdited(false);
   
      //  navigate(`/practice/app/b2c-offer-manager/review-offer/${newId}`);
       navigate(`/practice/app/b2c-domain/${domain_id}/review-offer/${newId}`);
      
      } catch (err) {
        console.error(err);
        toast({ title: "Error creating offer", status: "error" });
      }
    };
  
    const handleUpdateOffer = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      // guard

      try {

          if (isDraft) {
            await axios.put(`${b2c_apiurl}/update-offer/${offer_id}`, offer, {
              headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
            });

            if (isMappingEdited) {
              await axios.delete(`${b2c_apiurl}/offer/${offer_id}/delete-offer-product-mappings`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
              });
              await axios.post(`${b2c_apiurl}/offer/${offer_id}/create-offer-product-mappings`, mappings, {
                headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
              });
            }
          }

          if(isPlacementEdited)
          {
                        // --- UPDATE PLACEMENT ---
        await axios.put(`${b2c_apiurl}/offer/${offer_id}/placement`, offerDomainPlacement, {
            headers: {Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
          });
          }

        toast({ title: "Offer updated", status: "success" });
        setIsMappingEdited(false);

        setIsOfferEdited(false);
        setIsPlacementEdited(false);
      } catch (err) {
        console.error(err);
        toast({ title: "Error updating offer", status: "error" });
      }
    };
  
    const handleSaveOffer = () => {
      isCreating ? handleCreateOffer() : handleUpdateOffer();
      setIsEditing(false);
    };
  
    const handleUpdateClick = async () => {
        setIsEditing(true);
    }

    const handlePublishClick = async () => {
      try {
        const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
        await axios.put(`${b2c_apiurl}/offer/${offer_id}/publish`,offer , {
          headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
        toast({ title: "Offer Published", status: "success" });

        loadAllData();

     } catch (err: any) {
    console.error(err);

        const message =
          err?.response?.data?.detail ||
          "Error publishing offer";

        toast({
          title: message,
          status: "error",
        });
      }
    };
    const handleArchiveClick = async () => {
    try {
        const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
        await axios.put(`${b2c_apiurl}/offer/${offer_id}/archive`, offer, {
          headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
       

        toast({ title: "Offer Archived", status: "success" });

        loadAllData();

      } catch (err) {
        console.error(err);
        toast({ title: "Error archiving offer", status: "error" });
      }
    }

      const handleCancelOperation = () =>{
        setIsEditing(false);  
         loadAllData();
        };

        const handlePlacementInputChange = (
            e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
          ) => {
            const { name, value, type } = e.target;

            const finalValue =
              type === "checkbox"
                ? (e.target as HTMLInputElement).checked
                : value;

            setOfferDomainPlacement(prev => ({
              ...prev,
              [name]: finalValue,
            }));

            setIsPlacementEdited(true);
          };

  return (
    <Box as="main" mx="auto" p={10} >

 {/* Offer Details Top Bar */}
    <Box bg={useColorModeValue("gray.100", "gray.700")} p={4} borderRadius="sm" mb={4}>
    <Flex direction={["column", "row"]} justify="space-between" align={["flex-start", "center"]} wrap="wrap">
        <Heading size="lg">{offer.name || "Unnamed Offer"}</Heading>
        <HStack spacing={2} mt={[2, 0]}>
        <Badge colorScheme={
            (offer.status != "ARCHIVED")? "purple" :"orange"
        }>
            {offer.status}
        </Badge>
        </HStack>
    </Flex>

    <Flex mt={3} wrap="wrap" fontSize="sm" color={useColorModeValue("gray.600", "gray.400")}>
        <Text mr={4}><strong>Created:</strong> {new Date(offer.created_at).toLocaleDateString()}</Text>
        <Text><strong>Updated:</strong> {new Date(offer.updated_at).toLocaleDateString()}</Text>
    </Flex>
    </Box>

{/* Operations Buttons */}
    <Box>
    {showActionButtons && (
        <HStack spacing={2} mt={4}>
            <Button
            size="sm"
            borderRadius="sm"
            onClick={handleUpdateClick}
            isDisabled={!isUpdateButtonEnabled}
            colorScheme="blue"
            >
            Update Offer
            </Button>

            <Button
            size="sm"
            borderRadius="sm"
            onClick={handlePublishClick}
            isDisabled={!isPublishButtonEnabled}
            colorScheme="cyan"
            >
            Publish Offer
            </Button>

          <Button
            size="sm"
            borderRadius="sm"
            onClick={handleArchiveClick}
            isDisabled={!isArchivedButtonEnabled}
            colorScheme="teal"
            >
            Archive Offer
            </Button>

          {isEditing && (
            <Button size={"sm"} variant="outline" colorScheme="red" onClick={handleCancelOperation}>
              Cancel
            </Button>
          )}

        </HStack>
        )}
    </Box>

    {/* Offer Name & Description */}
    <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="md">
    <fieldset disabled={!(isCreating || (isEditing && isDraft))}>
        <Text mb={4} fontSize="md" fontWeight="bold">Name & Description</Text>
        <VStack spacing={4} align="stretch">
        <FormControl id="name" isRequired>
            <Input
            name="name"
            placeholder="Offer Name*"
            size="sm"
            value={offer.name}
            onChange={handleInputChange}
            />
        </FormControl>

        {/* Slug */}
        <FormControl id="slug" isRequired>
          <Input
            name="slug"
            placeholder="Slug*"
            size="sm"
            value={offer.slug}
            onChange={handleInputChange}
          />
        </FormControl>

        <FormControl id="description" isRequired>
             <Textarea
            name="description"
            placeholder="Offer Description*"
            size="sm"
            value={offer.description}
            onChange={handleInputChange}
            />
        </FormControl>

                        {/* Long Description */}
                <FormControl id="long_description">
                  <Textarea
                    name="long_description"
                    placeholder="Offer Long Description"
                    size="sm"
                    value={offer.long_description || ""}
                    onChange={handleInputChange}
                  />
                </FormControl>

        <FormControl id="duration_label" isRequired>
            <Input
            name="duration_label"
            placeholder="Offer Duration Label*"
            size="sm"
            value={offer.duration_label}
            onChange={handleInputChange}
            />
        </FormControl>

        <FormControl id="total_price" isRequired>
            <Input
            name="total_price"
            placeholder="Offer Price*"
            size="sm"
            value={offer.total_price}
            onChange={handleInputChange}
            />
        </FormControl>

{/*           <FormControl id="currency" isRequired>
            <Input
            name="currency"
            placeholder="Currency*"
            size="sm"
            value={offer.currency}
            onChange={handleInputChange}
            />
        </FormControl> */}

                  <Text>
                    {offer.currency}
                    </Text>


      {/* Domain */}
      <FormControl id="domain_id" isRequired isDisabled>
      <Flex align="center" gap={4}>
          <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Domain</FormLabel>
          <Select
          placeholder="Select Domain"
          name="domain_id"
          size="sm"
          value={offer.domain_id}
          onChange={handleInputChange}
          >
          {domains.map((domain) => (
              <option key={domain.domain_id} value={domain.domain_id}>
              {domain.name}
              </option>
          ))}
          </Select>
      </Flex>
      </FormControl>


        </VStack>
    </fieldset>
 
    </Box>

    {/* Offer Product Mapping */}
      <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="md">
    <fieldset disabled={!(isCreating || (isEditing && isDraft))}>
      <Text mb={4} fontSize="md" fontWeight="bold">Product Terms</Text>
      <Table variant="simple" size="sm">
          <Thead>
              <Tr>
              <Th>Product</Th>
              <Th>Duration Days</Th>
              <Th>Actions</Th>
              </Tr>
          </Thead>
          <Tbody>
              {mappings.map((mapping, index) => {
              const selectedProd = products.find(
                  (pr) => pr.product_id === mapping.product_id
              );


              return (
                  <Tr key={index}>
                    <Td>
                      <Select
                        size="sm"
                        placeholder="Select product"
                        value={mapping.product_id || ''}
                        isDisabled={ !mapping.isDraft }
                        onChange={e =>
                          updateMapping(index, {
                            product_id: Number(e.target.value)
                          })
                        }
                      >
                        {getAvailableProducts(index).map(pr => (
                          <option
                            key={pr.product_id}
                            value={pr.product_id}
                          >
                            {pr.name}
                          </option>
                        ))}
                      </Select>
                    </Td>


                    <Td>
                      <Input
                        size="sm"
                        type="number"
                        value={mapping.duration_days}
                        isDisabled={ !mapping.isDraft }
                        onChange={e =>
                          updateMapping(index, { duration_days: Number(e.target.value) })
                        }
                      />
                    </Td>
                    <Td>
                      {mapping.isDraft ? (
                        <HStack spacing={1}>
                          <IconButton
                            aria-label="Confirm"
                            icon={<FiCheck />}
                            size="sm"
                            colorScheme="green"
                            isDisabled={!mapping.product_id}
                            onClick={() => confirmDraftMapping(index)}
                          />
                          <IconButton
                            aria-label="Cancel"
                            icon={<FiX />}
                            size="sm"
                            colorScheme="red"
                            onClick={() => cancelDraftMapping(index)}
                          />
                        </HStack>
                      ) : (
                        <HStack spacing={1}>
                          <IconButton
                            aria-label="Edit"
                            icon={<FiEdit />}
                            colorScheme="blue"
                            size="sm"
                            onClick={() => editMapping(index)}
                            isDisabled={hasDraftMappingRow()}
                          />
                          <IconButton
                            aria-label="Delete"
                            icon={<FiTrash />}
                            size="sm"
                            colorScheme="red"
                          //   onClick={() => deleteMapping(index)}
                            onClick={() => {
                              if (window.confirm("Are you sure you want to remove this Product?")) {
                                  deleteMapping(index)};
                              }
                          }
                            isDisabled={hasDraftMappingRow()}
                          />
                        </HStack>
                      )}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>

              <Button
                  onClick={addMapping}
                  size="sm"
                  borderRadius="sm"
                  colorScheme="blue"
                  mt={2}
                  isDisabled={
                      hasDraftMappingRow() ||
                      mappings.length >= products.length 
                  }
                  >
                  Add Product Terms to Offer
                  </Button>


              </fieldset>

      </Box>

      {/* Offer Placement & Presentation */}
      {!isArchived && 
      (
      <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="md">
        <fieldset disabled={!(isCreating || isEditing)}>
          <Text mb={4} fontSize="md" fontWeight="bold">
            Presentation & Placement
          </Text>

          <VStack spacing={4} align="stretch">

            {/* Sequence (Read Only) */}
            <FormControl>
              <FormLabel fontSize="sm">Display Sequence</FormLabel>
              <Input
                size="sm"
                value={offerDomainPlacement.sequence ?? "Not Assigned"}
                isReadOnly
              />
            </FormControl>

            {/* Badge Text */}
              <FormControl>
                <FormLabel fontSize="sm">Badge Text</FormLabel>
                <Input
                  size="sm"
                  name="badge_text"
                  value={offerDomainPlacement.badge_text || ""}
                  onChange={handlePlacementInputChange}
                />
              </FormControl>

            {/* Badge Theme */}
              <FormControl>
                <FormLabel fontSize="sm">Badge Theme</FormLabel>
                <Select
                  size="sm"
                  name="badge_theme"
                  value={offerDomainPlacement.badge_theme}
                  onChange={handlePlacementInputChange}
                >
                  {["BLUE","ORANGE","YELLOW","GREEN","TEAL","PINK","PURPLE"].map(
                    (theme) => (
                      <option key={theme} value={theme}>
                        {theme}
                      </option>
                    )
                  )}
                </Select>
              </FormControl>

            {/* Promotion Tier */}
              <FormControl>
                <FormLabel fontSize="sm">Promotion Tier</FormLabel>
                <Select
                  size="sm"
                  name="promotion_tier"
                  value={offerDomainPlacement.promotion_tier}
                  onChange={handlePlacementInputChange}
                >
                  {["STANDARD", "FEATURED", "HERO"].map((tier) => (
                    <option key={tier} value={tier}>
                      {tier}
                    </option>
                  ))}
                </Select>
              </FormControl>

            {/* Theme Key */}
                <FormControl>
                  <FormLabel fontSize="sm">Offer Theme</FormLabel>
                  <Select
                    size="sm"
                    name="theme_key"
                    value={offerDomainPlacement.theme_key}
                    onChange={handlePlacementInputChange}
                  >
                    {["BLUE","ORANGE","YELLOW","GREEN","TEAL","PINK","PURPLE"].map(
                      (theme) => (
                        <option key={theme} value={theme}>
                          {theme}
                        </option>
                      )
                    )}
                  </Select>
                </FormControl>

            {/* Is Featured */}
{/*               <FormControl display="flex" alignItems="center">
                <Checkbox
                  name="is_featured"
                  isChecked={offerDomainPlacement.is_featured}
                  onChange={handlePlacementInputChange}
                >
                  Featured Offer
                </Checkbox>
              </FormControl> */}

          </VStack>
        </fieldset>
      </Box>
      )}
    {/* Save Button */}
    {showSaveButton && (
        <Box textAlign="left" mt={4}>
            <Button
            mb={2}
            colorScheme="teal"
            size="sm"
            borderRadius="sm"
            onClick={handleSaveOffer}
            isDisabled={hasDraftMappingRow()||!(isOfferEdited||isMappingEdited||isPlacementEdited)}
            >
            Save Offer
            </Button>
            
        </Box>
        )}
    </Box>
  );
};

export default B2CReviewOffer;
